export default {
  apivalidatecode: '/api/account/validatecode', //获取图形验证码
    apismscode: '/api/account/getsmscode', //获取短信验证码
    apiregister: '/api/account/register', //注册
    apilogin: '/api/account/login', //登录
    apigetdoctorlist: '/api/apply/getdoctorlist', //获取主治医生列表
    apiaddapply: '/api/apply/addapply', //提交申请
    apigetlist: '/api/apply/getlist', //我的申请
    apigetdetail: '/api/apply/getdetail', //我的申请详细
    apieditapply: '/api/apply/editapply', //修改我的申请详细
    apideleteapply: '/api/apply/deleteapply', //删除我的申请
    apiuploadpic: 'api/account/uploadpic',  //上传图片
    apigeprojectnoticelistbypage: 'api/article/geprojectnoticelistbypage',  //公示列表
    apigetnoticedetail: 'api/article/getnoticedetail',  //公示详细
    apigethelplistbypage: 'api/article/gethelplistbypage', //帮助列表
    apigethelpdetail: 'api/article/gethelpdetail', //帮助详细
  }


// WEBPACK FOOTER //
// ./src/http/api.js